// ts-prune-ignore-next
module.exports = {};
module.exports.default = module.exports;
